import React, { Component } from "react";
import {
  Container,
  Form,
  Button,
  Nav,
  NavItem,
  NavLink,
  UncontrolledCollapse,
  CardBody,
  Card,
  FormGroup,
  Label,
  Input,
  Col,
  CustomInput,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import {  Modal } from 'react-bootstrap'
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { sample } from "lodash"
library.add(faClock);


class Randomtest1 extends Component {
 
  constructor(props) {
    super(props);
    this.state = {
      count: 20
    };
  }

  /*    <Button  id="toggler" style={{ marginBottom: '1rem' }} className="rdTest1" href='/randomtest2'><h5>ก.อดีต</h5></Button><br></br>
                                <UncontrolledCollapse  toggler="#toggler" >   
                                    <Button   href='/randomtest13'>ยืนยัน   ก.</Button>
                                </UncontrolledCollapse>    */
  render() {
    const { count } = this.state;
    let box = ["/randomtest13","/randomtest13_2"]
    let box2 = ["/randomtest2","/randomtest2_2"]
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">1. เวลาใดที่กินเวลาน้อยที่สุด</h3>
              <br></br>
              <Button className="rdTest1"  href={sample(box2)}>
                <h5>ก.อดีต</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box)}>
                <h5>ข.ปัจจุบัน</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box2)}>
                <h5>ค.อนาคต</h5>
              </Button>
              <br></br>
            </Form>
            <Button className="rdTestbt1" href="/randomtest2">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberW">1</h3>
            <h3 className="ranknumberW1">2</h3>
            <h3 className="ranknumberW1">3</h3>
            <h3 className="ranknumberW1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/randomtest2");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest1;
